import React from "react";
import { Button } from "./ui/button";
import { Alert, AlertDescription } from "./ui/alert";
import { Eye, ArrowLeft, Shield } from "lucide-react";

const ImpersonationBanner = ({ userName, userType, onReturnToAdmin, className = "" }) => {
  return (
    <Alert className={`border-orange-200 bg-orange-50 mb-4 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-center justify-between w-full gap-3">
        <div className="flex items-center gap-2 sm:gap-3 min-w-0 flex-1">
          <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
            <Shield className="w-4 h-4 sm:w-5 sm:h-5 text-orange-600" />
            <Eye className="w-4 h-4 sm:w-5 sm:h-5 text-orange-600" />
          </div>
          <AlertDescription className="text-orange-800 min-w-0">
            <span className="font-semibold text-sm sm:text-base block sm:inline truncate">
              Stai visualizzando come {userName}
            </span>
            <span className="text-xs sm:text-sm block mt-1 sm:mt-0">
              Modalità Amministratore • {userType === 'candidato' ? 'Dashboard Candidato' : 'Dashboard Agenzia'}
            </span>
          </AlertDescription>
        </div>
        
        <Button
          onClick={onReturnToAdmin}
          variant="outline"
          size="sm"
          className="bg-white hover:bg-orange-100 border-orange-300 text-orange-700 rounded-xl w-full sm:w-auto text-xs sm:text-sm px-2 sm:px-4 py-1.5 sm:py-2 flex-shrink-0"
        >
          <ArrowLeft className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
          <span className="sm:hidden">Admin</span>
          <span className="hidden sm:inline">Torna al Pannello Admin</span>
        </Button>
      </div>
    </Alert>
  );
};

export default ImpersonationBanner;